import React from 'react';
import { Pencil, Trash2 } from 'lucide-react';
import './vendor.css';

const VendorListTable = ({ vendors, onEdit, onDelete, onCreatePurchase }) => {
  return (
    <div className="vendor-table-wrapper mt-2">
      <table className="vendor-table">
        <thead>
          <tr>
            <th>Vendor Name</th>
            <th>Type</th>
            <th>Category</th>
            <th>Address</th>
            <th>GST</th>
            <th>Mobile</th>
            <th>State</th>
            <th>City</th>
            <th>Created On</th>
            <th>Create Purchase</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {vendors?.map((vendor) => (
            <tr key={vendor.id || vendor.vendorId}>
              <td>{vendor.vendorName}</td>
              <td>{vendor.vendorType}</td>
              <td>{vendor.vendorCategory}</td>
              <td>{vendor.vendorAddress}</td>
              <td>{vendor.gst}</td>
              <td>{vendor.mobile}</td>
              <td>{vendor.state}</td>
              <td>{vendor.city}</td>
              <td>{vendor.createdOn}</td>
              <td>
                <button
                  className="vendor-btn-create-purchase"
                  onClick={() => onCreatePurchase(vendor)}
                >
                  + Purchase
                </button>
              </td>
              <td>
                <button
                  className="vendor-icon-btn"
                  title="Edit"
                  onClick={() => onEdit(vendor)}
                >
                  <Pencil size={16} />
                </button>
                <button
                  className="vendor-icon-btn delete"
                  title="Delete"
                  onClick={() =>
                    window.confirm('Delete this vendor?') && onDelete(vendor.id || vendor.vendorId)
                  }
                >
                  <Trash2 size={16} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default VendorListTable;
